export var ThemeMediaSize;
(function (ThemeMediaSize) {
    ThemeMediaSize[ThemeMediaSize["XSmall"] = 10] = "XSmall";
    ThemeMediaSize[ThemeMediaSize["Small"] = 20] = "Small";
    ThemeMediaSize[ThemeMediaSize["MediumSmall"] = 25] = "MediumSmall";
    ThemeMediaSize[ThemeMediaSize["Medium"] = 30] = "Medium";
    ThemeMediaSize[ThemeMediaSize["MediumLarge"] = 40] = "MediumLarge";
    ThemeMediaSize[ThemeMediaSize["Large"] = 50] = "Large";
    ThemeMediaSize[ThemeMediaSize["XLarge"] = 60] = "XLarge";
})(ThemeMediaSize || (ThemeMediaSize = {}));
